import { OnboardingTrialFlag } from '@sdk/authentication/types/apiTypes';

export const getFirstUncompletedItem = (
  steps: OnboardingTrialFlag[]
): OnboardingTrialFlag | null => {
  const firstNotCompletedItem = steps.find((step) => !step.completed);
  return firstNotCompletedItem;
};
